import type { MessageDescriptor } from 'react-intl';
import { categoryMessages } from './messages';

export type CategoryId = '2484' | '2485' | '2486' | '2487' | '2488' | '2489' | '2490';

export interface Category {
  id: CategoryId;
  name: MessageDescriptor;
  description: MessageDescriptor;
}

export type Preferences = Record<CategoryId, boolean>;

export const CATEGORIES: readonly Category[] = [
  {
    id: '2484',
    name: categoryMessages.businessInsightsName,
    description: categoryMessages.businessInsightsDescription,
  },
  {
    id: '2485',
    name: categoryMessages.capitalName,
    description: categoryMessages.capitalDescription,
  },
  {
    id: '2486',
    name: categoryMessages.inPersonPaymentsName,
    description: categoryMessages.inPersonPaymentsDescription,
  },
  {
    id: '2487',
    name: categoryMessages.newsAndEventsName,
    description: categoryMessages.newsAndEventsDescription,
  },
  {
    id: '2488',
    name: categoryMessages.paymentMethodsName,
    description: categoryMessages.paymentMethodsDescription,
  },
  {
    id: '2489',
    name: categoryMessages.productsName,
    description: categoryMessages.productsDescription,
  },
  {
    id: '2490',
    name: categoryMessages.surveysAndFeedbackName,
    description: categoryMessages.surveysAndFeedbackDescription,
  },
] as const;

export const CATEGORY_BY_ID: Record<CategoryId, Category> = CATEGORIES.reduce(
  (acc, c) => ({ ...acc, [c.id]: c }),
  {} as Record<CategoryId, Category>,
);
